module.exports = __webpack_public_path__ + "static/media/281.76d8fdf0.svg";